<template>
  <li class="row-content" :class="containerClass">
    <i v-if="!isText" class="fa fa-file row-content--side"></i>
    <span class="row-content--main">
      <span class="t-500">{{ 'Project' | pluralize(countProjects) }}:</span> {{ countProjects }}
    </span>
  </li>
</template>

<script>
export default {
  name: 'searchPartialPublicationCount',
  props: {
    countProjects: {
      type: Number,
      default: 0
    },
    containerClass: {
      type: String,
      default: ''
    },
    isText: {
      type: Boolean,
      default: false
    }
  }
}
</script>
